import { combineReducers } from 'redux'
import loginSlice from './slice/loginSlice';
import sideBarSlice from './slice/sideBarSlice';
import userPermisssionSlice from './slice/userPermisssionSlice';
import authApiSlice from './slice/authApiSlice';
import flowBuilderSlice from './slice/flowBuilderSlice';
import clientDetails from './slice/clientSlice';


// export default combineReducers({
//   login:loginSlice,
//   sideBar:sideBarSlice,
//   chat:chatSlice,
//   callModal:callModalSlice,
//   floaterVideoCall:floaterVideoCallSlice,
//   authApi: authApiSlice,
//   // [apiSlice.reducerPath]: apiSlice.reducer,
//   // [apiContacts.reducerPath]:apiContacts.reducer
// })
const allReducers  = combineReducers({
  login:loginSlice,
  sideBar:sideBarSlice,
  userPermisssion:userPermisssionSlice,
  authApiSlice:authApiSlice,
  flowBuilder:flowBuilderSlice,
  clientDetails:clientDetails,

  // [apiSlice.reducerPath]: apiSlice.reducer,
  // [apiContacts.reducerPath]:apiContacts.reducer
})

const rootReducer = (state:any, action:any) => {
  if (action.type === 'RESET_APP') {
    state = undefined;
  }

  return allReducers(state, action);
}

export default rootReducer;